import React from 'react'
import Swal from 'sweetalert2'
import Constant from '../../../Constant.js'
import axios from 'axios'
import MUIDataTable from 'mui-datatables'
import Button from '../../../common/CustomComponents/Button.js'
import Select from 'react-select'
import ActivitiesController from '../../../common/activitiesController/ActivitiesController.js'

class TripCabinPrice extends React.Component {
  constructor(props) {
    super(props) // required to access `this.props`

    // State initialization
    this.state = {
      id: null,
      cruise_id: this.props.match.params.cruiseId || '',
      trip_id: this.props.match.params.tripId || '',
      cabin_id: null,
      min_passengers: 0,
      adult_price: 0,
      child_price: 0,
      cabin_availability: 0,
      order: 0,

      is_saving: false,
      cabin_list: [],
      trip_cabin_list: [],
    }
  }

  async componentDidMount() {
    await this.loadCruiseCabins()
    await this.loadTripCabins()
  }

  loadCruiseCabins = async () => {
    await axios
      .get(Constant.getAPI() + `/trips/get-all-cruise-cabins/${this.state.cruise_id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            cabin_list: res.data.data
              ?.filter((item) => item.is_active && !item.is_deleted)
              ?.map((item) => ({
                label: `${item.name_en} / ${item.name_ar}`,
                value: item.id,
              })),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  loadTripCabins = async () => {
    await axios
      .get(Constant.getAPI() + `/trips/trip-cabins/${this.state.trip_id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            trip_cabin_list: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  clearAddForm = () => {
    this.setState({
      id: null,
      cabin_id: null,
      min_passengers: 0,
      adult_price: 0,
      child_price: 0,
      cabin_availability: 0,
      order: 0,
    })
  }

  onSaveData = () => {
    if (
      this.state.adult_price <= 0 ||
      this.state.child_price <= 0 ||
      this.state.cabin_availability <= 0 ||
      this.state.min_passengers <= 0
    ) {
      Swal.fire('Validation Error', `Please check entered data`, 'error')
      return
    }

    let data = {
      ...(this.state.id && { id: this.state.id }),
      adult_price: this.state.adult_price,
      child_price: this.state.child_price,
      trip_id: this.state.trip_id,
      cabin_id: this.state.cabin_id ? this.state.cabin_id.value : null,
      order: this.state.order,
      cabin_availability: this.state.cabin_availability,
      min_passengers: this.state.min_passengers,
    }

    this.setState({ is_saving: true })

    axios
      .post(Constant.getAPI() + '/trips/save-trip-cabins', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState({ is_saving: false })
        if (res.status === 200) {
          Swal.fire('Added !', `Cabin has been Saved`, 'success')
          this.clearAddForm()
          this.loadTripCabins()
        }
      })
      .catch((err) => {
        this.setState({ is_saving: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleCabinClear = () => {
    this.setState({ cabin_id: null })
  }

  handleCabinChange = (event) => {
    this.setState({ cabin_id: event })
  }

  deleteTripCabin = async (id) => {
    await axios
      .delete(Constant.getAPI() + `/trips/delete-trip-cabin/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          Swal.fire('Deleted !', `Deleted successfully`, 'success')
          this.setState(
            {
              trip_cabin_list: [],
            },
            () => {
              this.loadTripCabins()
            }
          )
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  editTripCabin = (id) => {
    const tripCabin = this.state.trip_cabin_list.find((itm) => itm.id === id)

    this.setState({
      id: tripCabin.id,
      min_passengers: tripCabin.min_passengers,
      adult_price: tripCabin.adult_price,
      child_price: tripCabin.child_price,
      cabin_availability: tripCabin.cabin_availability,
      order: tripCabin.order,
      cabin_id: this.state.cabin_list.find((itm) => itm.value == tripCabin.cabin_id),
    })
  }

  render() {
    const columns = [
      {
        name: 'cabin_id',
        label: 'Cabin Name',
        options: {
          customBodyRender: (id) => {
            let cabinDetails = this.state?.cabin_list.find((itm) => itm.value === id)
            return cabinDetails?.label || id
          },
        },
      },
      {
        name: 'adult_price',
        label: 'Adult Price',
      },
      {
        name: 'child_price',
        label: 'Child Price',
      },
      {
        name: 'cabin_availability',
        label: 'Available Cabin',
      },
      {
        name: 'min_passengers',
        label: 'Min Passengers',
      },
      {
        name: 'order',
        label: 'Order',
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div className="d-flex justify-content-start align-items-center">
                <span
                  onClick={() => this.editTripCabin(id)}
                  className="m-r-15 text-muted"
                >
                  <i className="f-20 icofont icofont-ui-edit text-dark"></i>{' '}
                </span>
                <span
                  onClick={() => this.deleteTripCabin(id)}
                  className="m-r-15 text-muted"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      search: false,
      filter: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Trip Cabins</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="card card-body">
                <div className="row">
                  <div
                    className="col-md-12"
                    style={{ borderBottom: '1px solid #ddd', marginBottom: 10 }}
                  >
                    <div className="row">
                      <label className="col-sm-3 col-form-label">
                        Trip ID: {this.state.trip_id}
                        <br />
                        Cruise ID: {this.state.cruise_id}
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Select Cabin</label>
                      <div className="col-sm-9">
                        <Select
                          name="cabin_id"
                          value={this.state.cabin_id}
                          onChange={this.handleCabinChange}
                          options={this.state.cabin_list}
                          isMulti={false}
                          isSearchable={true}
                          isClearable={false}
                          onClear={this.handleCabinClear}
                          placeholder="Select Options"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Min Passengers</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          name="min_passengers"
                          id="min_passengers"
                          placeholder={`Min Passenger`}
                          onChange={this.handleChange}
                          value={this.state.min_passengers}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Adult Price</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          name="adult_price"
                          id="adult_price"
                          placeholder={`Adult Price`}
                          onChange={this.handleChange}
                          value={this.state.adult_price}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Child Price</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          name="child_price"
                          id="child_price"
                          placeholder={`Child Price`}
                          onChange={this.handleChange}
                          value={this.state.child_price}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Available Cabins</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          name="cabin_availability"
                          id="cabin_availability"
                          placeholder={`Available Cabin Count`}
                          onChange={this.handleChange}
                          value={this.state.cabin_availability}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Order</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          name="order"
                          id="order"
                          placeholder={`Enter Order`}
                          onChange={this.handleChange}
                          value={this.state.order}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row float-right p-3">
                  <Button
                    onClick={this.onSaveData}
                    startIcon={<i className="icofont icofont-save"></i>}
                  >
                    {this.state.is_saving ? 'Saving...' : 'Save'}
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={this.clearAddForm}
                  >
                    Clear
                  </Button>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="dt-responsive table-responsive">
                    <MUIDataTable
                      className="table-responsive"
                      data={this.state.trip_cabin_list}
                      columns={columns}
                      options={options}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TripCabinPrice
